const PERCENTAGE_THRESHOLDS = {
  normal: 0,
  large: 51.2,
  warning: 80,
  maximum: 100,
};

const WARNING_COLORS = {
  normal: "#93D173",
  large: "#F2E391",
  warning: "#E8C38B",
  maximum: "#FAAFAF",
};

const DEFAULT_MAX_LESSON_SIZE = 1024;
const BYTES_IN_MB = 1000000;

export { PERCENTAGE_THRESHOLDS, WARNING_COLORS, DEFAULT_MAX_LESSON_SIZE, BYTES_IN_MB };
